// extracted by mini-css-extract-plugin
export default {"ContextMenu":"ContextMenu_ContextMenu__zc-Wb","renameBtn":"ContextMenu_renameBtn__h2sL9","deleteBtn":"ContextMenu_deleteBtn__t4+rk"};